module.exports = __webpack_public_path__ + "static/media/faq-system-req.122ccdb8.svg";